export enum EnglishLanguages {
	EN = 'en',
	EN_GB = 'en_GB',
}

export enum ButtonType {
	QUICK_REPLY = 'QUICK_REPLY',
	CALL_TO_ACTION_URL = 'URL',
	CALL_TO_ACTION_PHONE_NUMBER = 'PHONE_NUMBER',
	COPY_CODE = 'COPY_CODE',
	OTP = 'OTP',
	FLOW = 'FLOW',
}

export enum flowTemplateFormFieldIds {
	REVIEW = 'REVIEW',
	PROMOTION = 'PROMOTION',
	DOCUMENT = 'DOCUMENT',
	DEFAULT = 'DEFAULT',
}

export enum FormFieldIds {
	BODY_TEXT = 'bodyText',
	BUTTONS = 'buttons',
	TEXT_HEADER_INPUT = 'headerInputValue',
	FOOTER_INPUT = 'footerInput',
	FILE_URL_DOC = 'fileUrlDoc',
	MEDIA_DOC = 'mediaDoc',
	VIDEO = 'video',
	FILE_URL = 'fileUrl',
}

export enum Content {
	INTERACTIVE = 'INTERACTIVE',
	CAROUSEL = 'CAROUSEL',
	LTO = 'LIMITED_TIME_OFFER',
	AUTHENTICATION = 'AUTHENTICATION',
	RICH_CARD = 'RICH_CARD',
}

export enum VariablesMapKey {
	HEADER = 'header',
	BODY = 'body',
	BUTTON = 'button',
	CAROUSEL = 'carousel',
	VERIFICATION_CODE = 'verification_code',
}

export enum MessageTemplateSortOptions {
	NAME_ASC = 'NAME_ASC',
	NAME_DESC = 'NAME_DESC',
	CREATED_FIRST = 'CREATED_FIRST',
	CREATED_LAST = 'CREATED_LAST',
}

export enum TemplateTypeTexts {
	TEXT_AND_MEDIA = 'Text & Media',
	CAROUSEL = 'Carousel',
	LTO = 'Offer with Coupon',
	AUTHENTICATION = 'Authentication',
}
export enum TemplateCategory {
	UTILITY = 'UTILITY',
	AUTHENTICATION = 'AUTHENTICATION',
	MARKETING = 'MARKETING',
}

export enum TemplateStatus {
	APPROVED = 'approved',
	REJECTED = 'rejected',
	SUBMITTED = 'submitted',
	CREATED = 'created',
	PENDING = 'pending',
	DELETION_PENDING = 'PENDING_DELETION',
	UNDER_REVIEW = 'Under Review',
}

export enum INPUT_MEDIA_TYPES {
	IMAGE = 'IMAGE',
	VIDEO = 'VIDEO',
	PDF = 'PDF',
	URL = 'URL',
}

export enum INPUT_CARD_HEIGHT {
	SMALL = 'SHORT_HEIGHT',
	MEDIUM = 'MEDIUM_HEIGHT',
}
export enum INPUT_CARD_WIDTH {
	SMALL = 'SMALL_WIDTH',
	MEDIUM = 'MEDIUM_WIDTH',
}
export enum INPUT_CARD_ORIENTATION {
	VERTICAL = 'VERTICAL',
	HORIZONTAL = 'HORIZONTAL',
}

export enum INPUT_CARD_ALIGNMENT {
	LEFT = 'LEFT',
	RIGHT = 'RIGHT',
}

export enum SYNC_STATUS {
	DONE = 'DONE',
	FAILED = 'FAILED',
	IN_PROGRESS = 'IN_PROGRESS',
	QUEUED = 'QUEUED',
}

export enum MESSAGE_TEMPLATE_TUTORIAL {
	TEMPLATE_V2_TUTORIAL = 'CREATE_MESSAGE_TEMPLATES_V2_TUTORIAL',
	LTO_TUTORIAL = 'CREATE_MESSAGE_TEMPLATES_V2_TUTORIAL_LTO',
	AUTHENTICATION_TUTORIAL = 'CREATE_MESSAGE_TEMPLATES_V2_TUTORIAL_AUTHENTICATION',
}

export enum RCS_BUTTON_TYPE {
	POSTBACK = 'QUICK_REPLY',
	URL = 'URL',
	DIALER = 'PHONE_NUMBER',
	FLOW = 'FLOW',
}

export enum RCS_TEMPLATE_TYPE_UPPER_CASE {
	RICH_CARD = 'RICH_CARD',
	CAROUSEL = 'CAROUSEL',
	TEXT = 'TEXT',
	TEXT_MEDIA = 'TEXT_MEDIA',
}

export enum RCS_TEMPLATE_TYPES {
	CAROUSEL = 'carousel',
	RICH_CARD = 'rich_card',
	TEXT = 'text_message',
	FLOW = 'flow',
	TEXT_MEDIA = 'text_message_with_media',
}

export enum RCS_ACTION_TYPE {
	URL_ACTION = 'url_action',
	DIALER_ACTION = 'dialer_action',
	REPLY = 'reply',
	POSTBACK = 'postback',
	URL = 'url',
	PHONE_NUMBER = 'phoneNumber',
	FLOW = 'flow',
}
